export const DEFAULT_CLIP = {
  isNew: false,
  isEditing: false,
  id: null,
  name: '',
  startTime: 0,
  endTime: 0,
  duration: 0
}
